import { render } from "./BusinessSettings.vue?vue&type=template&id=df589cd8"
import script from "./BusinessSettings.vue?vue&type=script&lang=js"
export * from "./BusinessSettings.vue?vue&type=script&lang=js"

import "./BusinessSettings.vue?vue&type=style&index=0&id=df589cd8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__